import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObserversModule } from '@angular/cdk/observers';
import { HttpClientModule } from '@angular/common/http';

import { SecondarySidebarComponent } from './secondary-sidebar/secondary-sidebar.component';

import { QuickviewService } from './quickview/quickview.service';
import { ModalModule, TypeaheadModule } from 'ngx-bootstrap';

import { ParallaxDirective } from './parallax/parallax.directive';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { FormGroupDefaultDirective } from './forms/form-group-default.directive';
import { ViewDirective } from './view/view.directive';

import { pgCollapseModule } from './collapse/collapse.module';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ContainerComponent } from './container/container.component';
import { pageContainer } from './container/page-container.component';
import { RouterModule } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { MenuAltComponent } from './menu/menu-alt.component';
import { MenuIconComponent } from './menu/menu-icon.component';

import { ListItemComponent } from './list-view/list-item/list-item.component';
import { ListViewContainerComponent } from './list-view/list-view-container/list-view-container.component';
import { pgRetinaDirective } from './retina/retina.directive';
import { ClientListComponent } from '../../view/client/client-list/client-list.component';
import { DotMenuModule } from '../../view/components/dot-menu/dot-menu.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ClientDetailComponent } from '../../view/client/client-detail/client-detail.component';
import { ButtonLoadingModule } from '../../view/components/btn-loading/btn-loading.module';
import { pgSelectModule } from './select/select.module';
import { pgDatePickerModule } from './datepicker/datepicker.module';
import { NguiMapModule } from '@ngui/map';
import { environment } from '../../../environments/environment';
import { ProgressModule } from './progress/progress.module';
import { POSUserDetailComponent } from '../../view/pos-user/pos-user-detail/pos-user-detail.component';
import { POSUserListComponent } from '../../view/pos-user/pos-user-list/pos-user-list.component';
import { POSListComponent } from '../../view/pos/pos-list/pos-list.component';
import { POSDetailComponent } from '../../view/pos/pos-detail/pos-detail.component';
import { EventDetailComponent } from '../../view/event/event-detail/event-detail.component';
import { EventListComponent } from '../../view/event/event-list/event-list.component';
import { TokenDetailComponent } from '../../view/token/token-detail/token-detail.component';
import { TokenListComponent } from '../../view/token/token-list/token-list.component';
import { TransactionListComponent } from '../../view/transaction/transaction-list/transaction-list.component';
import { PaginatedSelectModule } from '../../view/components/paginated-select/paginated-select.module';
import { RefundComponent } from '../../view/report/report-refund/report-refund.component';
import { SalesComponent } from '../../view/report/report-sales/report-sales.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { TokenReportComponent } from '../../view/report/report-token/report-token.component';
import { VoucherDetailComponent } from '../../view/voucher/voucher-detail/voucher-detail.component';
import { VoucherListComponent } from '../../view/voucher/voucher-list/voucher-list.component';
import { TextMaskModule } from 'angular2-text-mask';
import { XReportComponent } from '../../view/report/report-xreport/report-xreport.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    ObserversModule,
    TypeaheadModule.forRoot(),
    ProgressModule,
    PerfectScrollbarModule,
    RouterModule,
    TextMaskModule,
    DotMenuModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    ModalModule,
    ButtonLoadingModule,
    NgxPermissionsModule,
    pgSelectModule,
    pgDatePickerModule,
    PaginatedSelectModule,
    NgxEchartsModule,
    NguiMapModule.forRoot({ apiUrl: environment.mapUrl })],
  declarations: [
    SecondarySidebarComponent,
    ParallaxDirective,
    BreadcrumbComponent,
    FormGroupDefaultDirective,
    ViewDirective,
    ContainerComponent,
    pageContainer,
    MenuComponent,
    MenuAltComponent,
    MenuIconComponent,
    ListItemComponent,
    ListViewContainerComponent,
    pgRetinaDirective,
    ClientDetailComponent, ClientListComponent,
    POSUserDetailComponent,POSUserListComponent,
    VoucherDetailComponent,VoucherListComponent,
    POSListComponent,POSDetailComponent,
    EventListComponent,EventDetailComponent,
    TokenListComponent,TokenDetailComponent,
    TransactionListComponent,RefundComponent,SalesComponent,TokenReportComponent, XReportComponent
  ],
  exports: [
    SecondarySidebarComponent,
    ParallaxDirective,
    BreadcrumbComponent,
    FormGroupDefaultDirective,
    ViewDirective,
    pgCollapseModule,
    ContainerComponent,
    pageContainer,
    MenuComponent,
    MenuAltComponent,
    MenuIconComponent,
    ListItemComponent,
    ListViewContainerComponent,
    pgRetinaDirective,
    DotMenuModule, 
    TextMaskModule,
    ButtonLoadingModule,
    PaginatedSelectModule,
    NgxPermissionsModule,
    ClientDetailComponent, ClientListComponent,
    POSUserDetailComponent,POSUserListComponent,
    POSListComponent,POSDetailComponent,
    VoucherDetailComponent,VoucherListComponent,
    EventListComponent,EventDetailComponent,
    TokenListComponent,TokenDetailComponent,
    TransactionListComponent,RefundComponent,SalesComponent,TokenReportComponent, XReportComponent,
    NgxEchartsModule
  ],
  providers: [
    QuickviewService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class SharedModule { }
